import { Component, AfterViewInit, OnDestroy, Input } from '@angular/core'
import { InsaService } from '../../../insa-services'
//import { ChartModel } from '../../../insa-models/chart.model'
import { appStateProvider } from '../../../insa-providers'
import { Router } from '@angular/router'
import { GenericChartsModule } from '../../../insa-custom-scripts'
//import { appConfig } from '../../../../insaweb.config'
//import { GridsterItem } from 'angular-gridster2/dist/gridsterItem.interface';
//import { InsaMainWindowComponent } from '../insa-main-window/insa-main-window.component';
//import { setTimeout } from 'core-js/library/web/timers';

@Component({
    selector: "bar-chart-widget",
    templateUrl: 'mainWindowBarChart.component.html'
})

export class MainWindowBarChart implements OnDestroy, AfterViewInit{
    private randomId = Date.now().toString() + Math.ceil((Math.random() * 100000)).toString();
    private barChartId = "BarChart" + this.randomId;
    private barChartWrapperId = "bar-chart-wrapper" + this.randomId;
    private perfDetails = [{ "Description": "First", "Value": 50 }, { "Description": "Second", "Value": 12 }, { "Description": "Third", "Value": 5 }];
    private _chartWidth: number;
    private _chartHeight: number;
    private minVal: number;
    private maxVal: number;

    @Input() 
    set chartWidth(chartWidth: number){
        this._chartWidth = chartWidth;
        this.ResizeChart();
    }

    @Input() 
    set chartHeight(chartHeight: number){
        this._chartHeight = chartHeight;
        this.ResizeChart();
    }

    constructor(private _insaService: InsaService, private _appStateProvider: appStateProvider, private _router: Router) {
    }

    ResizeChart(){
        let chart: kendo.dataviz.ui.Chart = $("#" + this.barChartId).data("kendoChart");
        if (chart != null) {
            chart.options.chartArea = { background: "", width: $("#" + this.barChartWrapperId).width(), height: $("#" + this.barChartWrapperId).height() }
            chart.redraw();
        }
    }

    CalculateMinAndMax(){
        this.minVal = Math.min.apply(Math, this.perfDetails.map(function (val) { return val.Value; }));
        this.maxVal = Math.max.apply(Math, this.perfDetails.map(function (val) { return val.Value; }));
    }

    ngAfterViewInit(){
        this.CalculateMinAndMax();
        GenericChartsModule.KendoInitGenericBarChart("#" + this.barChartId, this.perfDetails, "BAR CHART", this.minVal, this.maxVal, false, $("#" + this.barChartWrapperId).width(), false, false);
        setTimeout(() => {
            this.ResizeChart()},
             300);
    }

    ngOnDestroy(){

    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-main/insa-main-widgets/mainWindowBarChart.component.ts